<template>
<FormRow class="designation" inline>
  <FormSelect field="custom.designation">
    <option selected="selected" value="General Donation">General Donation</option>
    <option value="Ben Zakkai Honor Society">Ben Zakkai Honor Society</option>
    <option value="NCSY Region">NCSY Region</option>
    <option value="NCSY Summer">NCSY Summer</option>
    <option value="Yarchei Kallah">National Yarchei Kallah</option>
    <option value="Education Donation">NCSY Education</option>
    <option value="Innovation Lab">Innovation Lab</option>
    <option value="JSU Expansion">JSU Expansion</option>
  </FormSelect>

  <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'NCSY Region'">
    <option value="">Select a Region</option>
    <option value="Alumni">Alumni</option>
    <option value="Argentina">Argentina</option>
    <option value="Atlanta">Atlanta</option>
    <option value="Atlantic Seaboard">Atlantic Seaboard</option>
    <option value="Canada">Canada</option>
    <option value="Canada Dinner">Canada - Gala 2024</option>
    <option value="Central East">Central East</option>
    <option value="Chile">Chile</option>
    <option value="Israel">Israel</option>
    <option value="Mexico">Mexico</option>
    <option value="Midwest">Midwest</option>
    <option value="National">National</option>
    <option value="New Jersey">New Jersey</option>
    <option value="New York">New York</option>
    <option value="New England">Northeast (New England &amp; Upstate)</option>
    <option value="Oregon">Oregon</option>
    <option value="Southern">Southern</option>
    <option value="Southwest">Southwest</option>
    <option value="West Coast">West Coast</option>
  </FormSelect>

  <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'NCSY Summer'">
    <option value="">Select a Trip</option>
    <option value="General Summer Scholarship Fund">General Summer Scholarship Fund</option>
    <option value="Tefillin">Summer Tefillin Scholarship Fund</option>
    <option value="BILT Scholarship">BILT Scholarship Fund</option>
    <option value="Camp Sports Scholarship">Camp Sports Scholarship Fund</option>
    <option value="EURO ICE Scholarship">Euro ICE Scholarship Fund</option>
    <option value="GIVE Scholarship">GIVE Scholarship Fund</option>
    <option value="GIVE USA Scholarship">GIVE USA Scholarship Fund</option>
    <option value="ICE Scholarship">ICE Israel Scholarship Fund</option>
    <option value="JOLT Scholarship">JOLT Scholarship Fund</option>
    <option value="Kollel Scholarship">Kollel Scholarship Fund</option>
    <option value="Michlelet Scholarship">Michlelet Scholarship Fund</option>
    <option value="TJJ Ambassadors Poland Scholarship">TJJ Ambassadors Poland Scholarship Fund</option>
    <option value="TJJ Ambassadors Scholarship">TJJ Ambassadors Scholarship Fund</option>
    <option value="TJJ Scholarship">TJJ Scholarship Fund</option>
  </FormSelect>

  <ErrorLabel field="custom.designation" style="text-align:right"/>
</FormRow>
</template>
<script lang="ts">
import {
  defineComponent,
  watch
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { getValue } = usePaymentForm()

    return {
      getValue,
    }
  },
})
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width:50%;
    max-width:50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
